import { LitElement, html, svg } from 'lit';

export class IconSearch24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 25 25"><title>Forstørrelsesglass</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.915 18.91A9.44 9.44 0 1 0 6.531 1.536a9.44 9.44 0 0 0 7.384 17.374ZM16.897 16.897l7.321 7.322"></path></svg>`; }
}
if (!customElements.get('f-icon-search24', IconSearch24)) {
  customElements.define('f-icon-search24', IconSearch24);
}